// eslint-disable-next-line
import Vue from 'vue';
import Router from 'vue-router';
import Autonomy from './views/Autonomy.vue';
Vue.use(Router);

export default new Router({
  mode: 'history',
  hashbang: false,
  linkActiveClass: 'active',
  routes: [
    {
      path: '*',
      name: 'Landing',
      component: Autonomy
    },
    {
      path: '/',
      name: 'Landing',
      component: Autonomy
    },
    {
      path: '/:lang?/:country?/',
      name: 'Home',
      component: Autonomy
    }
  ]
});
